import React, { useRef, useState, useContext, useEffect } from 'react'
import { format } from 'date-fns'
import { FiCheck, FiPlus, FiTrash, FiX, FiFileText, FiUpload, FiEdit, FiAlertTriangle, FiFilePlus, FiEye, FiEyeOff, FiEdit2 } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Formik, Form, FieldArray, Field } from 'formik'
import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'
import { Tabs, TabPanel } from 'react-tabs'
import { FaMobileAlt } from 'react-icons/fa'
import ReactTooltip from 'react-tooltip'

import Card from '../../../../../components/Card'
import FileStack from '../../../../../components/FileStack'
import Table from '../../../../../components/Table'
import Spinner from '../../../../../components/Spinner'
import Modal from '../../../../../components/Modal'
import { api, authHeaders } from '../../../../../services/api'
import formUtils from '../../../../../util/form'
import { Button, Select, Textbox, Switch, Textarea, Checkbox } from '../../../../../components/Form'
import masks from '../../../../../util/masks'
import scrollUtils from '../../../../../util/scroll'
import { GlobalContext } from '../../../../../contexts/GlobalContext'
import { getAge } from '../../../../../util/date'
import { useInnerWidth } from '../../../../../util/viewport'

const steps = [
	{
		name: 'Informações essenciais'
	},
	{
		name: 'Dados clínicos'
	},
	{
		name: 'Deficiências'
	},
	{
		name: 'Doenças'
	},
	{
		name: 'Medicamentos uso contínuo'
	},
	{
		name: 'Contatos de emergência'
	}
]

const baseInitialValues = {
	arquivos: [],
	medico: '',
	crm: '',
	data_exame: '',
	data_resultado: '',
	tipo: { label: 'Exame', value: 'exame' },
	especialidade: '',
	nome_exame: ''
}

const tiposExame = [
	{
		label: "Resultado de exame",
		value: "exame"
	},
	{
		label: "Laudo",
		value: "laudo"
	},
	{
		label: "Receita médica",
		value: "receita"
	},
	{
		label: "Atestado médico",
		value: "atestado"
	},
	{
		label: "Outros",
		value: "outros"
	}
]

export default function ({ pessoaId, refetchProntuario, prontuario, isFetchingProntuario }) {
	const fileUploadRef = useRef()

	const { width } = useInnerWidth()

	const { user, checkRecurso, isDadosVisiveis, toggleIsDadosVisiveis } = useContext(GlobalContext)

	const [initialValues, setInitialValues] = useState(baseInitialValues)
	const [showFormAddExame, setShowFormAddExame] = useState(false)
	const [exameVisualizacao, setExameVisualizacao] = useState(null)
	const [showCadastro, setShowCadastro] = useState(false)
	const [activeStep, setActiveStep] = useState(0)
	const [formData, setFormData] = useState({})
	const [informacoesEdicao, setInformacoesEdicao] = useState(null)
	const [dadosClinicosEdicao, setDadosClinicosEdicao] = useState(null)
	const [deficienciasEdicao, setDeficienciasEdicao] = useState(null)
	const [doencasEdicao, setDoencasEdicao] = useState(null)
	const [medicamentosEdicao, setMedicamentosEdicao] = useState(null)
	const [contatosEdicao, setContatosEdicao] = useState(null)
	const [cienciaConfirmada, setCienciaConfirmada] = useState(false)
	const [isLoadingExames, setIsLoadingExames] = useState(false)
	const [exameEmEdicao, setExameEmEdicao] = useState(null)

	const { data: pessoa } = useQuery({
		queryKey: ['get-pessoa-data'],
		queryFn: async () => {
			const response = await api.get(`pessoa/${pessoaId}`, authHeaders())

			return response
		},
		enabled: !!pessoaId
	})

	const { data: dadosRelacao } = useQuery({
		queryKey: ['obter-relacoes-familia'],
		queryFn: async () => {
			const response = await api.get('familia', authHeaders())

			const membro = response?.find(item => item.pessoa.id === pessoaId)

			return membro || null
		},
		enabled: !!pessoaId
	})

	const { data: especialidades } = useQuery({
		queryKey: ['get-especialidades'],
		queryFn: async () => {
			const response = await api.get('especialidade')

			return response
		}
	})

	const { mutate: handleExcluirExame } = useMutation({
		mutationFn: async data => {
			await api.delete(`prontuario_exame/${data.id}`, authHeaders())

			setIsLoadingExames(true)

			await refetchProntuario()

			toast.success('O item foi excluído com sucesso!')

			setIsLoadingExames(false)
		}
	})

	const { mutate: createMutation } = useMutation({
		mutationFn: async data => {
			await api.post('prontuario', data, authHeaders())

			toast.success('Parabéns! Seu prontuário foi criado!')

			clearCadastro()

			refetchProntuario()
		}
	})

	const { mutate: updateMutation } = useMutation({
		mutationFn: async data => {
			await api.put(`prontuario/${pessoaId || user.pessoa.id}`, data, authHeaders())

			toast.success('Seu prontuário foi atualizado!')

			clearCadastro()

			refetchProntuario()
		}
	})

	const { data: tiposContato } = useQuery({
		queryKey: ['get_tipos_contato'],
		queryFn: async () => {
			const response = await api.get('tipo_contato')

			return response
		},
		placeholderData: [],
		refetchOnWindowFocus: false
	})

	// const { data: recursos } = useQuery({
	// 	queryKey: ['get_recursos'],
	// 	queryFn: async () => {
	// 		try {
	// 			const response = await api.get('pessoa', {
	// 				params: {
	// 					modulos_contratados: true
	// 				},
	// 				...authHeaders()
	// 			})

	// 			const moduloContratado = response?.find(item => item.modulo_id === 1)

	// 			const recursos = moduloContratado?.recursos || []

	// 			console.log('recursos', recursos)

	// 			return recursos
	// 		} catch (e) {
	// 			console.log(e)
	// 		}
	// 	},
	// 	placeholderData: [],
	// 	enabled: !!user
	// })

	const { data: recursos } = useQuery({
		queryKey: ['obter-recursos-prontuario-owner'],
		queryFn: async () => {
			const response = await api.get(`pessoa/${pessoa.id}/recursos`, authHeaders())

			const assinaturaAtiva = response.assinaturas.find(assin => assin.status === 'authorized')

			if(assinaturaAtiva) {
				return assinaturaAtiva.plano.recursos
			}

			return []
		},
		placeholderData: [],
		enabled: !!pessoa
	})

	function handlePrepareEdit() {
		setActiveStep(0)

		// Informações
		const informacoesData = Object.entries(prontuario.informacoes).reduce((result, [key, value]) => {
			return {
				...result,
				[key]: value !== '' && !Number.isNaN(+value) ? !!+value : value
			}
		}, {})

		setInformacoesEdicao({
			...informacoesData,
			data_nascimento: prontuario.pessoa.data_nascimento ? format(new Date(prontuario.pessoa.data_nascimento), 'dd/MM/yyyy') : ''
		})

		// Dados clinicos
		const dadosClinicosData = Object.entries(prontuario.dados_clinicos).reduce((result, [key, value]) => {
			return {
				...result,
				[key]: { label: value, value }
			}
		}, {})

		setDadosClinicosEdicao(dadosClinicosData)

		// Deficiências
		setDeficienciasEdicao({
			deficiencias: prontuario.deficiencias.map(({ descricao }) => ({ descricao }))
		})

		// Doenças
		setDoencasEdicao({
			doencas: prontuario.doencas.map(({ doenca }) => ({ descricao: doenca }))
		})

		// Medicamentos
		setMedicamentosEdicao({
			medicamentos: prontuario.medicamentos.map(({ medicamento }) => ({ descricao: medicamento }))
		})

		// Contatos
		setContatosEdicao({
			contatos: prontuario.contatos.map(contato => ({
				id: contato.id,
				nome: contato.nome,
				valor: contato.valor,
				tipo_contato: {
					label: contato.tipo.descricao,
					value: contato.tipo.id
				}
			}))
		})
	}

	async function handleGoToNextStep(values) {
		values = formUtils.extractFormValues(values)

		let data = values

		if (values.group) {
			const groupName = values.group
			delete values.group

			data = {
				[groupName]: values
			}
		}

		setFormData(old => ({
			...old,
			...data
		}))

		setActiveStep(old => old <= steps.length - 2 ? old + 1 : old)
	}

	async function handleFinish(values) {
		try {
			values = formUtils.extractFormValues(values)

			const data = {
				...formData,
				...values,
				pessoa_id: pessoaId
			}

			const mutation = informacoesEdicao === null ? createMutation : updateMutation

			mutation(data)

			setCienciaConfirmada(false)
		} catch (e) {
			toast.error(e.msg)
		}
	}

	function clearCadastro() {
		setShowCadastro(false)

		setInformacoesEdicao(null)
		setDoencasEdicao(null)
		setDadosClinicosEdicao(null)
		setMedicamentosEdicao(null)
		setContatosEdicao(null)
		setCienciaConfirmada(false)
	}

	function handlePrepararEdicaoExame(exame) {
		setExameEmEdicao(exame)

		setInitialValues({
			arquivos: exame.arquivos_exame ? exame.arquivos_exame.map(e => e.arquivo) : [],
			crm: exame.crm || '',
			medico: exame.medico === 'não informado' ? '' : exame.medico,
			especialidade: exame.especialidade ? { label: exame.especialidade.descricao, value: exame.especialidade.id } : '',
			data_exame: exame.data_exame || '',
			data_resultado: exame.data_resultado || '',
			tipo: tiposExame?.find(tipo => tipo.value === exame.tipo) || { label: 'Exame', value: 'exame' },
			nome_exame: exame.descricao || ''
		})
	}

	async function handleSubmit(values, { setSubmitting }) {
		try {
			setSubmitting(true)
			setIsLoadingExames(true)

			if (!values.arquivos.length) {
				throw new Error('Você deve enviar pelo menos um arquivo.')
			}

			values.pessoa_id = pessoaId

			const formData = formUtils.extractFormValues(values)

			if (!exameEmEdicao) {
				await api.post('prontuario_exame', formData, authHeaders())
			} else {
				await api.put(`prontuario_exame/${exameEmEdicao.id}`, formData, authHeaders())
			}

			setTimeout(refetchProntuario, 2000)

			toast.success(exameEmEdicao ? 'Seu exame foi atualizado com sucesso!' : 'Seu exame foi anexado com sucesso!')
		} catch (e) {
			toast.error(e.msg || e.message)
		} finally {
			setIsLoadingExames(false)
			setSubmitting(false)
			setShowFormAddExame(false)
			setExameEmEdicao(null)
			setInitialValues(baseInitialValues)
		}
	}

	const eAssinanteVisualizandoMembro = user ? pessoa?.id !== user.pessoa.id : false
	const sexoMembro = !pessoa?.sexo ? '' : pessoa.sexo === 'M' ? 'Homem' : 'Mulher'

	let linhaDetalhes = sexoMembro

	if (dadosRelacao?.relacao.descricao) {
		linhaDetalhes += ` - ${dadosRelacao?.relacao.descricao}`
	}

	if (pessoa?.data_nascimento) {
		linhaDetalhes += ` - ${getAge(pessoa.data_nascimento)} anos`
	}

	if (!pessoa) {
		return <Spinner />
	}

	const recursosLista = recursos.map(recurso => recurso.identificador)

	return (
		<>
			<Card
				className={`
				animated fadeIn flex flex-col gap-4
				flex flex-col bg-white min-h-[43vh]
			`}
			>
				<div className="flex justify-between">
					{eAssinanteVisualizandoMembro ? (
						<div className="flex gap-6 items-center">
							{pessoa.usuario?.avatar?.link && (
								<img src={pessoa.usuario.avatar.link} alt="" className="rounded-full w-48 shadow.md object-cover" />
							)}

							<div className="flex flex-col text-slate-800">
								<span className="font-normal">Prontuário médico de</span>

								<h1 className="text-slate-800">
									{pessoa.nome}
								</h1>

								<span className="font-normal mt-6">{linhaDetalhes}</span>
							</div>
						</div>
					) : (
						<h1 className="text-slate-800">
							Prontuário médico
						</h1>
					)}

					{!!prontuario && (
						<div className="flex gap-4 items-center">
							<span
								onClick={toggleIsDadosVisiveis}
								className="flex gap-1 text-sky-700 text-xs select-none rounded-md bg-sky-100 p-2 h-fit cursor-pointer hover:bg-sky-100/60 sm:bg-transparent sm:hover:bg-transparent"
								data-tip="Mostre ou oculte os dados do seu prontuário."
								data-for="prontuario-acoes-tooltip"
							>
								{isDadosVisiveis ? (
									<>
										<FiEye size={24} className="sm:hidden" />
										<FiEye size={18} className="hidden sm:block" />
										<span className="hidden sm:block">Ocultar dados</span>
									</>
								) : (
									<>
										<FiEyeOff size={24} className="sm:hidden" />
										<FiEyeOff size={18} className="hidden sm:block" />
										<span className="hidden sm:block">Exibir dados</span>
									</>
								)}
							</span>

							<span
								onClick={handlePrepareEdit}
								className="flex gap-1 text-sky-700 text-xs select-none rounded-md bg-sky-100 p-2 h-fit cursor-pointer hover:bg-sky-100/60 sm:bg-transparent sm:hover:bg-transparent"
								data-tip="Atualize os dados do seu prontuário."
								data-for="prontuario-acoes-tooltip"
							>
								<FiEdit size={24} color="#0084d1" className="sm:hidden" />
								<FiEdit size={16} color="#0084d1" className="hidden sm:block" />
								<span className="hidden sm:block">Editar</span>
							</span>
						</div>
					)}
				</div>

				{isFetchingProntuario ? (
					<div className="col-span-2 flex justify-center">
						<Spinner label="Carregando prontuário..." />
					</div>
				) : !prontuario ? (
					<div
						className="group pb-4 pt-8 px-8 bg-emerald-100/70 hover:bg-emerald-200/80 transition-all hover:opacity-70 border border-slate-400 text-slate-800 border-dashed flex justify-center items-center rounded-md flex flex-col gap-4 cursor-pointer"
						onClick={() => { setShowCadastro(true) }}
					>
						<FiPlus size={24} color="#424242" />

						<span className="text-center font-medium" style={{ fontSize: 16 }}>
							{eAssinanteVisualizandoMembro ? `Criar o prontuário de ${pessoa.nome}` : 'Criar meu prontuário'}
						</span>

						<span className="text-sm text-center text-slate-600/90 group-hover:text-slate-700">
							Antes de continuar, tenha em mãos as informações básicas a respeito do seu perfil de saúde, como tipo sanguíneo, doenças, alergias, remédios de uso contínuo, etc.
						</span>
					</div>
				) : (
					<div className="flex flex-col gap-4 text-slate-800">
						{(checkRecurso('atualizacao-prontuario') || checkRecurso('inclusao-plano-individual') || recursosLista.includes('atualizacao-prontuario') || recursosLista.includes('inclusao-plano-individual')) && (
							<ProntuarioResumo prontuario={prontuario} recursos={recursos} />
						)}

						{(checkRecurso('gerenciamento-exames') || checkRecurso('inclusao-plano-individual') || recursosLista.includes('gerenciamento-exames') || recursosLista.includes('inclusao-plano-individual')) && (
							<>
								<div className="text-lg font-bold" id="header-exames">Exames e laudos médicos</div>

								{exameVisualizacao ? (
									<div className="flex flex-col gap-3 border rounded-md border-slate-300 py-3 px-4 animated fadeInUp faster bg-white">
										<div className="grid grid-cols-[auto_3rem] gap-2 lg:gap-4">
											<div className="w-full flex flex-col lg:flex-row lg:justify-between gap-4 lg:items-center font-semibold">
												<span>{`Solicitante: ${exameVisualizacao.medico}`}</span>

												<div className="flex flex-col lg:flex-row gap-2 lg:gap-6">
													<span>Data do exame: {exameVisualizacao.data_exame}</span>
													<span>Data do resultado: {exameVisualizacao.data_resultado}</span>
												</div>
											</div>

											<FiX size={40} className="hover:bg-slate-200 text-slate-500 p-2 cursor-pointer rounded-md" onClick={() => { setExameVisualizacao(null) }} />
										</div>

										<div>
											<FileStack
												name="arquivos"
												files={exameVisualizacao.arquivos_exame.map((item, idx) => ({
													...item.arquivo,
													name: `Arquivo ${idx + 1}`
												}))}
											/>
										</div>

										{/* {!!exameVisualizacao.diagnostico && (
											<>
												<div className="flex flex-col gap-2 mt-4">
													<span className="font-semibold">Análise superficial</span>

													<div className="relative flex gap-1 items-center">
														<FaRobot size={16} />
														<span className="text-xs"> (gerado pela nossa Inteligência Artificial)</span>
														
														<div className="group cursor-help">
															<FiHelpCircle size={13} className="text-slate-400" />

															<div 
																className="absolute hidden group-hover:flex flex-col gap-2 bg-white shadow-md border border-slate-100 p-3 rounded-sm left-0 lg:left-auto max-w-96" 
																style={{ fontSize: 13 }}
															>
																<h4 className="font-medium text-slate-800" style={{ fontSize: 14 }}>Validação Profissional Requerida</h4>
																<p>O conteúdo apresentado abaixo foi gerado com o auxílio de inteligência artificial. Embora tenhamos buscado fornecer informações úteis e precisas, ressaltamos que esta análise não substitui a orientação de um profissional qualificado. Recomendamos que você consulte um especialista para confirmar a veracidade, a aplicabilidade e a adequação das informações antes de tomar qualquer decisão com base nelas.</p>
															</div>
														</div>
													</div>
												</div>

												<p>{exameVisualizacao.diagnostico}</p>
											</>
										)} */}

										<div className="flex justify-center">
											<Button onClick={() => { setExameVisualizacao(null) }} className="">
												Voltar para a lista de exames
											</Button>
										</div>
									</div>
								) : !showFormAddExame && !exameEmEdicao ? (
									<div
										id="upload-exame-arquivo"
										className="border border-slate-300 rounded-md p-6 flex items-center bg-emerald-100/60 justify-center hover:bg-green-100 cursor-pointer"
										onClick={() => {
											setShowFormAddExame(true)
										}}
									>
										<div className="flex flex-col gap-4 text-slate-800 items-center text-center text-emerald-600 hover:text-emerald-800">
											<FiFilePlus size={32} />

											{!!prontuario?.exames.length ? (
												<span>Anexe aqui seu resultado de exame, laudo, receita médica, atestados, imagens, etc.</span>
											) : (
												<span>Anexe aqui seu primeiro resultado de exame, laudo, receita médica, atestados, imagens, etc.</span>
											)}
										</div>
									</div>
								) : (
									<Formik
										initialValues={initialValues}
										onSubmit={handleSubmit}
										enableReinitialize
									>
										{({ values, setFieldValue, isSubmitting }) => {
											const arquivos = values.arquivos || []
											const eExameOuLaudo = ['exame', 'laudo'].includes(values.tipo.value)

											return (
												<>
													<p style={{ fontSize: 13 }} className="text-slate-500">Os arquivos anexados e informações fornecidas neste cadastro são de responsabilidade do usuário.</p>

													<Form className="form-add-exame flex flex-col border border-slate-300 rounded-md p-4 bg-white animated fadeInUp faster" encType="multipart/form-data">
														<div className="flex gap-2 w-full justify-between">
															<span className="font-semibold">Preencha os dados do seu exame ou laudo médico e anexe-o abaixo.</span>
															<FiX
																size={40}
																className="hover:bg-slate-200 text-slate-500 p-2 cursor-pointer rounded-md"
																onClick={() => {
																	setShowFormAddExame(false)
																	setExameEmEdicao(null)
																}}
															/>
														</div>

														<p style={{ fontSize: 13 }} className="text-slate-500 my-3">As informações abaixo podem ser encontradas no resultado do seu exame ou laudo.</p>

														<div className="flex flex-col mr-3">
															<div className="flex flex-col md:flex-row">
																<Select
																	name="tipo"
																	label="Tipo"
																	containerClass="input-tipo"
																	onChange={(selected, meta) => setFieldValue(meta.name, selected)}
																	options={tiposExame}
																/>

																<Textbox
																	name="nome_exame"
																	label="Nome do documento"
																	containerClass="input-exame"
																/>
															</div>

															{eExameOuLaudo && (
																<div className="flex flex-col md:flex-row">
																	<Textbox
																		name="data_exame"
																		label="Data de realização"
																		mask={masks.date}
																		containerClass="input-data-exame"
																	/>

																	<Textbox
																		name="data_resultado"
																		label="Data do resultado"
																		mask={masks.date}
																		containerClass="input-data-resultado"
																	/>
																</div>
															)}

															<span className="text-sm mx-2 mt-4 text-slate-500">Preencha os campos abaixo somente se você tiver as informações do médico solicitante.</span>

															<div className="flex flex-col md:flex-row">
																<Textbox
																	name="crm"
																	label="CRM do médico solicitante"
																	mask={masks.numero}
																	containerClass="input-crm"
																/>

																<Textbox
																	name="medico"
																	label="Nome do médico solicitante"
																	containerClass="input-medico"
																/>

																<Select
																	name="especialidade"
																	label="Especialidade médica"
																	containerClass="input-especialidade"
																	options={especialidades.map(espec => ({
																		label: espec.descricao,
																		value: espec.id
																	}))}
																	onChange={(selected, meta) => {
																		setFieldValue(meta.name, selected)
																	}}
																/>
															</div>
														</div>

														<p style={{ fontSize: 13 }} className="text-slate-500 mt-3 mx-2">Obs.: Anexe um exame por vez. Envie seus exames no formato PDF ou imagens. O tamanho máximo para cada arquivo é 5MB.</p>

														<div className="flex flex-col gap-4 mt-3">
															<div className="w-fit">
																{!!arquivos?.length && (
																	<label htmlFor="arquivos">
																		<div className="button w-fit text-center">
																			Selecionar arquivos
																		</div>
																	</label>
																)}

																<input
																	type="file"
																	id="arquivos"
																	name="arquivos"
																	multiple
																	ref={fileUploadRef}
																	className="hidden"
																	onChange={e => {
																		const listaArquivos = Array.from(e.target.files)

																		let invalidFiles = 0
																		let motivoErro

																		const arquivosValidos = listaArquivos.filter(arquivo => {
																			const mimetype = arquivo.type
																			const extension = arquivo.name.split('.').at(-1)
																			const size = arquivo.size / 1024 ** 2 // em MB
																			const maxSize = 50 // em MB

																			if (size > maxSize) {
																				invalidFiles++
																				motivoErro = 'O arquivo enviado excedeu o tamanho máximo permitido (50MB).'
																				return false
																			}

																			if (!mimetype.startsWith('image/') && mimetype !== 'application/pdf') {
																				invalidFiles++
																				motivoErro = `Arquivos do tipo ${extension.toUpperCase()} não são aceitos.`
																				return false
																			}

																			return true
																		})

																		if (invalidFiles > 0) {
																			e.target.value = []

																			toast.error(motivoErro)
																		}

																		setFieldValue('arquivos', [...values.arquivos, ...arquivosValidos])
																	}}
																/>
															</div>
														</div>

														<FileStack
															name="arquivos"
															files={arquivos}
															uploadFieldName="arquivos"
														/>

														{!!arquivos.length && (
															<Button className="white text-center w-fit" style={{ marginBottom: 12 }}
																onClick={() => {
																	setFieldValue('arquivos', [])

																	document.querySelector('#arquivos').value = []
																}}
															>
																Descartar arquivos
																<FiTrash size={16} />
															</Button>
														)}

														<Button type="submit" className="mt-12 self-end" loading={isSubmitting}>
															Finalizar envio
															<FiCheck size={16} />
														</Button>
													</Form>
												</>
											)
										}}
									</Formik>
								)}

								{!exameVisualizacao && (
									<>
										{!prontuario || isLoadingExames ? (
											<Spinner label="Carregando seus documentos..." />
										) : prontuario.exames.length > 0 ? (
											<>
												{isDadosVisiveis ? (
													<>
														<Table
															headers={[
																{ name: 'tipo', value: 'Tipo', centered: true },
																{ name: 'descricao', value: 'Nome do documento' },
																{ name: 'medico_full', value: 'Médico solicitante', centered: true },
																{ name: 'data_exame', value: 'Data de realização', centered: true },
																{ name: 'data_resultado', value: 'Data do resultado', centered: true }
															]}
															tableId="tabela-exames"
															filterable
															hideOnSmallHeaders={[
																'tipo',
																'data_exame',
																'data_resultado'
															]}
															hideOffset={0}
															hideHeadersOffset={700}
															data={prontuario.exames.map(item => ({
																...item,
																descricao: item.descricao || '-',
																medico: item.nome || 'não informado',
																medico_full: item.nome ? `${item.nome} ${item.crm ? `(${item.crm})` : ''} ${item.especialidade?.descricao ? `- ${item.especialidade.descricao}` : ''}` : 'não informado',
																data_exame: item.data_exame ? format(new Date(item.data_exame), 'dd/MM/yyyy') : '-',
																data_resultado: item.data_resultado ? format(new Date(item.data_resultado), 'dd/MM/yyyy') : '-'
															}))}
															actions={[
																{
																	name: 'Visualizar',
																	action: setExameVisualizacao,
																	icon: FiFileText,
																	iconSize: 16
																},
																{
																	name: 'Editar',
																	action: handlePrepararEdicaoExame,
																	icon: FiEdit2,
																	iconSize: 16
																},
																{
																	name: 'Excluir',
																	action: handleExcluirExame,
																	icon: FiTrash,
																	iconSize: 16,
																	confirmation: 'Deseja realmente excluir definitivamente este item?'
																}
															]}
														/>

														{width < 700 && (
															<div className="py-2 px-3 rounded-md bg-slate-200 flex gap-3 items-center">
																<FaMobileAlt size={24} className="infinite-90-rotate" />
																<span>Se você girar o dispositivo, terá acesso ao tipo, data de realização e de entrega do documento.</span>
															</div>
														)}
													</>
												) : (
													<div className="bg-slate-800/15 rounded-md w-full h-24 animated fadeIn faster p-4 flex justify-center items-center text-slate-500">
														Seus exames estão ocultos
													</div>
												)}
											</>
										) : (
											<span className="italic text-sm text-slate-500 self-center mt-4">Nenhum exame ou laudo foi cadastrado até o momento.</span>
										)}
									</>
								)}
							</>
						)}
					</div>
				)}
			</Card>

			<Modal
				isOpen={showCadastro || !!informacoesEdicao}
				handleClose={clearCadastro}
				title="Cadastro do Prontuário do Cidadão"
			>
				<div>
					<Checkbox
						name="ciencia"
						label="Estou ciente que as informações abaixo são de minha inteira RESPONSABILIDADE."
						onChange={e => {
							setCienciaConfirmada(e.target.checked)
						}}
						containerStyle={{
							margin: '0 16px 24px'
						}}
						withoutForm
					/>

					{cienciaConfirmada ? (
						<>
							<div className="flex justify-between items-center mx-4 my-4">
								{steps.map((step, idx) => {
									const isActive = activeStep === idx
									const isPast = activeStep > idx

									return (
										<>
											<div
												key={step.name}
												className={twMerge(
													'rounded-full 2xl:rounded-xl bg-sky-600 h-fit w-full py-2 max-w-[36px] 2xl:w-fit 2xl:max-w-none flex flex-col justify-center items-center font-bold 2xl:px-4 text-white',
													classNames({
														'bg-sky-600': isActive,
														'bg-emerald-600': !isActive && isPast,
														'opacity-40': !isActive && !isPast
													})
												)}
											>
												<span style={{ fontSize: 16 }} className="font-semibold 2xl:hidden">{idx + 1}</span>
												<span style={{ fontSize: 18 }} className="font-semibold hidden 2xl:block">{idx + 1}</span>

												<div className="hidden 2xl:flex 2xl:ml-1 2xl:items-center whitespace-nowrap">
													{step.name}
												</div>
											</div>

											{idx < steps.length - 1 && (
												<hr className="border-0.5 border-sky-300 flex-1" />
											)}
										</>
									)
								})}
							</div>

							<Tabs selectedIndex={activeStep} forceRenderTabPanel>
								<TabPanel>
									<h3 className="2xl:hidden text-lg font-bold mx-2 text-slate-800 mb-4">{steps[activeStep].name}</h3>

									<Formik
										onSubmit={values => { handleGoToNextStep({ ...values, group: 'informacoes' }) }}
										initialValues={informacoesEdicao || {
											data_nascimento: pessoa?.data_nascimento ? format(new Date(pessoa.data_nascimento), 'dd/MM/yyyy') : '',
											alergias: '',
											pressao_alta: false,
											diabetes: false,
											marcapasso: false,
											protese_metalica: false,
											cardiaco: false,
											fumante: false,
											alcool: false
										}}
										enableReinitialize
									>
										{() => (
											<Form className="flex flex-col gap-5 md:grid md:grid-cols-2 xl:grid-cols-3">
												<Textbox
													label="Data de nascimento"
													name="data_nascimento"
													mask={masks.date}
												/>

												<div className="xl:col-span-2" />

												<Switch
													name="pressao_alta"
													label="Sofre de pressão alta?"
													className="xl:mt-6"
												/>

												<Switch
													label="É diabético?"
													name="diabetes"
													className="xl:mt-6"
												/>

												<Switch
													label="Possui marcapasso?"
													name="marcapasso"
													className="xl:mt-6"
												/>

												<Switch
													label="Possui prótese metálica?"
													name="protese_metalica"
												/>

												<Switch
													label="É cardíaco?"
													name="cardiaco"
												/>

												<Switch
													label="Ingere bebida alcoólica?"
													name="alcool"
												/>

												<Switch
													label="É fumante?"
													name="fumante"
												/>

												<Textarea
													label="Alergias e intolerâncias"
													name="alergias"
													containerClass="md:col-span-2 xl:col-span-3"
												/>

												<div className="col-span-2 xl:col-span-3 flex justify-end">
													<Button className="bg-sky-600 text-white w-full md:w-72 md:col-start-2 xl:col-start-3" type="submit">
														Próximo
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</TabPanel>

								<TabPanel>
									<h3 className="2xl:hidden text-lg font-bold mx-2 text-slate-800">{steps[activeStep].name}</h3>

									<Formik
										onSubmit={values => { handleGoToNextStep({ ...values, group: 'dados_clinicos' }) }}
										initialValues={dadosClinicosEdicao || {
											tipo_sangue: { label: 'Não informado', value: 'não informado' }
										}}
										enableReinitialize
									>
										{({ setFieldValue }) => (
											<Form className="flex flex-col">
												<Select
													name="tipo_sangue"
													label="Tipo sanguíneo"
													options={[
														{ label: 'Não informado', value: 'não informado' },
														{ label: 'A+', value: 'A+' },
														{ label: 'A-', value: 'A-' },
														{ label: 'B+', value: 'B+' },
														{ label: 'B-', value: 'B-' },
														{ label: 'AB+', value: 'AB+' },
														{ label: 'AB-', value: 'AB-' },
														{ label: 'O+', value: 'O+' },
														{ label: 'O-', value: 'O-' }
													]}
													onChange={(selected, meta) => setFieldValue(meta.name, selected)}
												/>

												<div className="flex flex-col-reverse sm:flex-row justify-between mt-4 mx-2 md:mx-0">
													<Button className="white w-fit self-center" onClick={() => { setActiveStep(old => old - 1) }}>
														Voltar
													</Button>

													<Button className="bg-sky-600 text-white w-full md:w-72 self-center" type="submit">
														Próximo
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</TabPanel>

								<TabPanel>
									<h3 className="2xl:hidden text-lg font-bold mx-2 text-slate-800">{steps[activeStep].name}</h3>

									<Formik
										onSubmit={handleGoToNextStep}
										initialValues={deficienciasEdicao || {
											deficiencias: []
										}}
										enableReinitialize
									>
										{({ values }) => (
											<Form className="flex flex-col">
												<FieldArray
													name="deficiencias"
													render={({ push, remove }) => {
														return (
															<div className="flex flex-col gap-2">
																{values.deficiencias.map((_, idx) => (
																	<div className="grid grid-cols-[1fr_44px] md:grid-cols-[300px_44px] border-b border-gray-300 pb-6" key={`doencas_${idx}`}>
																		<Textbox
																			name={`deficiencias.${idx}.descricao`}
																			label="Deficiência"
																		/>

																		<Button onClick={() => { remove(idx) }} className="white self-center" style={{ marginTop: 24 }} fab>
																			<FiTrash size={16} />
																		</Button>
																	</div>
																))}

																<Button onClick={() => push('')} className="white self-center" style={{ marginTop: 24 }}>
																	Incluir deficiência
																</Button>
															</div>
														)
													}}
												/>

												<div className="flex flex-col-reverse sm:flex-row justify-between mt-4 mx-2 md:mx-0">
													<Button className="white w-fit self-center" onClick={() => { setActiveStep(old => old - 1) }}>
														Voltar
													</Button>

													<Button className="bg-sky-600 text-white w-full md:w-72 self-center" type="submit">
														Próximo
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</TabPanel>

								<TabPanel>
									<h3 className="2xl:hidden text-lg font-bold mx-2 text-slate-800">{steps[activeStep].name}</h3>

									<Formik
										onSubmit={handleGoToNextStep}
										initialValues={doencasEdicao || {
											doencas: []
										}}
										enableReinitialize
									>
										{({ values }) => (
											<Form className="flex flex-col">
												<FieldArray
													name="doencas"
													render={({ push, remove }) => {
														return (
															<div className="flex flex-col gap-2">
																{values.doencas.map((_, idx) => (
																	<div className="grid grid-cols-[1fr_44px] md:grid-cols-[300px_44px] border-b border-gray-300 pb-6" key={`doencas_${idx}`}>
																		<Textbox
																			name={`doencas.${idx}.descricao`}
																			label="Doença"
																		/>

																		<Button onClick={() => { remove(idx) }} className="white self-center" style={{ marginTop: 24 }} fab>
																			<FiTrash size={16} />
																		</Button>
																	</div>
																))}

																<Button onClick={() => push('')} className="white self-center" style={{ marginTop: 24 }}>
																	Incluir doença
																</Button>
															</div>
														)
													}}
												/>

												<div className="flex flex-col-reverse sm:flex-row justify-between mt-4 mx-2 md:mx-0">
													<Button className="white w-fit self-center" onClick={() => { setActiveStep(old => old - 1) }}>
														Voltar
													</Button>

													<Button className="bg-sky-600 text-white w-full md:w-72 self-center" type="submit">
														Próximo
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</TabPanel>

								<TabPanel>
									<h3 className="2xl:hidden text-lg font-bold mx-2 mb-4 text-slate-800">{steps[activeStep].name}</h3>

									<Formik
										onSubmit={handleGoToNextStep}
										initialValues={medicamentosEdicao || {
											medicamentos: []
										}}
										enableReinitialize
									>
										{({ values }) => (
											<Form className="flex flex-col">
												<FieldArray
													name="medicamentos"
													render={({ push, remove }) => {
														return (
															<div className="flex flex-col gap-2">
																{values.medicamentos.map((_, idx) => (
																	<div className="grid grid-cols-[1fr_44px] md:grid-cols-[300px_44px] border-b border-gray-300 pb-6" key={`medicamentos_${idx}`}>
																		<Textbox
																			key={idx}
																			name={`medicamentos.${idx}.descricao`}
																			label="Medicamento de uso contínuo"
																		/>

																		<Button onClick={() => { remove(idx) }} className="white self-center" style={{ marginTop: 24 }} fab>
																			<FiTrash size={16} />
																		</Button>
																	</div>
																))}

																<Button onClick={() => push('')} className="white self-center">
																	Incluir medicamento
																</Button>
															</div>
														)
													}}
												/>

												<div className="flex flex-col-reverse sm:flex-row justify-between mt-4 mx-2 md:mx-0">
													<Button className="white w-fit self-center" onClick={() => { setActiveStep(old => old - 1) }}>
														Voltar
													</Button>

													<Button className="bg-sky-600 text-white w-full md:w-72 self-center" type="submit">
														Próximo
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</TabPanel>

								<TabPanel>
									<h3 className="2xl:hidden text-lg font-bold mx-2 mb-4 text-slate-800">{steps[activeStep].name}</h3>

									<Formik
										onSubmit={handleFinish}
										initialValues={contatosEdicao || {
											contatos: []
										}}
										enableReinitialize
									>
										{({ values, setFieldValue }) => {
											const quantidadeLimite = recursos?.find(rec => rec.identificador === 'contatos-emergencia')?.quantidade
											const maximoDeContatosAtingido = values.contatos.length >= quantidadeLimite

											return (
												<Form className="flex flex-col">
													<p className="text-slate-600 mx-2 mb-4">Você poderá incluir até <span class="font-semibold">{quantidadeLimite} contatos de emergência</span>.</p>

													<FieldArray
														name="contatos"
														render={({ push, remove }) => {
															return (
																<div className="flex flex-col gap-2">
																	{values.contatos.map((contato, idx) => {
																		let mask

																		switch (contato.tipo_contato?.value) {
																			case 1: // fixo residencial
																			case 2: // fixo comercial
																				mask = masks.phone
																				break
																			case 3: // celular ligações
																			case 4: // celular whatsapp
																			case 5: // celular telegram
																				mask = masks.mobile
																				break
																			default: // email 
																				mask = null
																				break
																		}

																		return (
																			<div className="flex flex-col lg:grid lg:grid-cols-4 border-b border-gray-300 pb-6" key={`contatos_${idx}`}>
																				<Select
																					name={`contatos.${idx}.tipo_contato`}
																					label="Tipo de contato"
																					options={tiposContato.map(tipo => (
																						{
																							label: tipo.descricao,
																							value: tipo.id
																						}
																					))}
																					onChange={(selected, meta) => setFieldValue(meta.name, selected)}
																				/>

																				{contato.tipo_contato && (
																					<>
																						<Textbox
																							name={`contatos.${idx}.valor`}
																							label={contato.tipo_contato.value === 6 ? "Digite o e-mail" : "Digite o número"}
																							mask={mask}
																							disabled={!contato.tipo_contato}
																						/>

																						<Textbox
																							name={`contatos.${idx}.nome`}
																							label="Nome do contato"
																						/>
																					</>
																				)}

																				<Button fab className="white w-8 h-8 self-end" style={{ marginTop: 12 }} onClick={() => { remove(idx) }}>
																					<FiTrash size={16} />
																				</Button>

																				<Field name={`contatos.${idx}.id`} type="hidden" />
																			</div>
																		)
																	})}

																	<Button
																		disabled={maximoDeContatosAtingido}
																		onClick={() => push({
																			tipo_contato: null,
																			valor: '',
																			nome: ''
																		})}
																		className="white self-center"
																	>
																		Incluir contato de emergência
																	</Button>

																	{maximoDeContatosAtingido && (
																		<div className="text-slate-600 text-center mx-2 mb-4 flex items-center justify-center gap-2 animated flash">
																			<FiAlertTriangle size={16} />
																			<span>{`Seu plano permite a inclusão de até ${quantidadeLimite} contatos de emergência.`}</span>
																		</div>
																	)}
																</div>
															)
														}}
													/>

													<div className="flex flex-col-reverse sm:flex-row justify-between mt-4 mx-2 md:mx-0">
														<Button className="white w-fit self-center" onClick={() => { setActiveStep(old => old - 1) }}>
															Voltar
														</Button>

														<Button className="bg-sky-600 text-white w-full md:w-72 self-center" type="submit">
															Finalizar
														</Button>
													</div>
												</Form>
											)
										}}
									</Formik>
								</TabPanel>
							</Tabs>
						</>
					) : (
						<p className="mx-4">Marque a caixinha acima para concordar com nossos termos e continuar.</p>
					)}
				</div>
			</Modal>

			<ReactTooltip
				id="prontuario-acoes-tooltip"
				effect="solid"
				type="light"
				backgroundColor='#ecf7fe'
				border="solid"
				borderColor="#ddd"
			/>
		</>
	)
}

function Tarja({ className }) {
	return (
		<div className={twMerge('bg-slate-800/15 rounded-sm w-full h-7 animated fadeIn faster', className)}></div>
	)
}

function ProntuarioResumo({ prontuario, recursos }) {
	const { checkRecurso, isDadosVisiveis } = useContext(GlobalContext)

	const recursosLista = recursos.map(recurso => recurso.identificador)

	return (
		<div id="dados-basicos" className="flex flex-col gap-4 md:grid md:grid-cols-2 xl:grid-cols-3">
			<div className="md:col-span-2 xl:col-span-3 flex flex-col sm:flex-row justify-between gap-4">
				{checkRecurso('gerenciamento-exames') || recursosLista.includes('gerenciamento-exames') ? (
					<Button onClick={() => { scrollUtils.toElement('#header-exames') }} style={{ marginLeft: 0 }}>
						<span>Enviar um exame ou laudo</span>
						<FiUpload size={16} />
					</Button>
				) : <div />}
			</div>

			<div className="flex flex-col gap-1 text-slate-800 row-span-3 leading-loose">
				<div className="text-lg font-bold">Informações relevantes</div>

				<div className="flex gap-1 items-center">
					Ingere bebidas alcoólicas:
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.alcool) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					É fumante:
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.fumante) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					É cardíaco:
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.cardiaco) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					É diabético(a):
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.diabetes) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					Tem pressão alta:
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.pressao_alta) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					Usa marcapasso:
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.marcapasso) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					Possui prótese metálica:
					{isDadosVisiveis ? <strong className="font-bold">{!!Number(prontuario.informacoes.protese_metalica) ? 'sim' : 'não'}</strong> : <Tarja className="w-12" />}
				</div>

				<div className="flex gap-1 items-center">
					Alergias / intolerâncias:
					{isDadosVisiveis ? <strong className="font-bold">{prontuario.informacoes.alergias || 'nenhuma alergia relatada'}</strong> : <Tarja className="w-12" />}
				</div>
			</div>

			<div className="flex flex-col gap-1 text-slate-800 leading-loose">
				<div className="text-lg font-bold">Dados clínicos</div>

				<div className="flex gap-1 items-center">
					Tipo sanguíneo (fator RH):
					{isDadosVisiveis ? <strong className="font-bold">{prontuario.dados_clinicos.tipo_sangue}</strong> : <Tarja className="w-12" />}
				</div>
			</div>

			<div className="flex flex-col gap-1 text-slate-800 leading-loose">
				<div className="text-lg font-bold">Deficiências</div>
				{prontuario.deficiencias.length > 0 ?
					(prontuario.deficiencias.map(({ descricao }) => isDadosVisiveis ? <p key={descricao}>{descricao}</p> : <Tarja />)) :
					<span className='italic text-slate-400'>Não informado</span>
				}
			</div>

			<div className="flex flex-col gap-1 text-slate-800 leading-loose">
				<div className="text-lg font-bold">Doenças</div>
				{prontuario.doencas.length > 0 ? (prontuario.doencas.map(({ doenca }) => isDadosVisiveis ? <p key={doenca}>{doenca}</p> : <Tarja />)) : <span className='italic text-slate-400'>Não informado</span>}
			</div>

			<div className="flex flex-col gap-1 text-slate-800 leading-loose">
				<div className="text-lg font-bold">Medicamentos de uso contínuo</div>
				{prontuario.medicamentos.length > 0 ? (prontuario.medicamentos.map(({ medicamento }) => isDadosVisiveis ? <p key={medicamento}>{medicamento}</p> : <Tarja />)) : <span className='italic text-slate-400'>Não informado</span>}
			</div>

			<div className="flex flex-col gap-1 text-slate-800 leading-loose">
				<div className="text-lg font-bold">Contatos de emergência</div>

				{!!prontuario.contatos.length ? (prontuario.contatos.map(contato => {
					const eEmail = contato.tipo === 'email'

					let extra = ''

					if (!eEmail) {
						extra = ` (${contato.tipo.descricao})`
					}

					return isDadosVisiveis ? (
						<div key={contato.id} dangerouslySetInnerHTML={{
							__html: `<span class="font-bold">${contato.valor}</span>${extra} - ${contato.nome}`
						}} />
					) : <Tarja />
				})) : <span className='italic text-slate-400'>Não informado</span>}
			</div>
		</div>
	)
}